module.exports = __webpack_public_path__ + "img/any-num19.7114b047.png";